import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon, useIonModal, IonLabel, IonToggle, IonSegment, IonSegmentButton, IonButton, IonModal, IonDatetime, IonDatetimeButton, IonSelect, IonSelectOption } from '@ionic/react';
import { add, chevronBack, chevronForward, gridOutline, peopleOutline, today } from 'ionicons/icons';

import { Calendar, EventProps, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment'
import 'moment/locale/pl'
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { useEffect, useState, createRef } from 'react';
import { getCurrentUser, getCurrentUserUID } from '../firebase/firebase';
import EventEditor from './EventEditor'
import { OverlayEventDetail } from '@ionic/core/components';
import CustomToolbar from './CustomToolbar'
import { setView } from './CustomToolbar'
import CustomEventView from './CustomEventView'
import CustomEventMonthView from './CustomEventMonthView'
import { addResourceListener } from '../firebase/resources';
import { addEvent, addEventListener, removeEvent, setEventUsers, updateCurrentEventDate } from '../firebase/events';
import { addUserListener, getUser } from '../firebase/users'
import { useHistory, useLocation } from 'react-router';
import CustomEventDayView from './CustomEventDayView';
import { addClientListener } from '../firebase/clients';
import { Capacitor } from '@capacitor/core';
import './CalendarPage.css';
import PushNotification from './PushNotification';
import { Cordova } from '@awesome-cordova-plugins/core';
import { addSettingsListener } from '../firebase/settings';
import dateformat, { i18n } from 'dateformat';

moment.locale('pl')
const localizer = momentLocalizer(moment)
const DnDCalendar = withDragAndDrop(Calendar);

const CalendarTab: React.FC = () => {


  const history = useHistory();
  const [events, setEvents] = useState([]);
  const [resources, setResources] = useState([]);
  const [selectedResources, setSelectedResources] = useState([]);
  const [users, setUsers] = useState<any>([]);
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [clients, setClients] = useState([]);
  const [currentCalendarDate, setCurrentCalendarDate] = useState(getDate());
  //const [showResource, setShowResource] = useState(true);
  const [defaultView, setDefaultView] = useState(Views.MONTH);
  const [managerSettings, setManagerSettings] = useState<any>({ calendarStartHour: 8, calendarEndHour: 21 });

  const translate = {
    week: 'Tydzień',
    work_week: 'Tydzień pracujący',
    day: 'Dzień',
    month: 'Miesiąc',
    previous: 'Poprzedni',
    next: 'Następny',
    today: `Dziś`,
    agenda: 'Agenda',
    showMore: function showMore(total: any) {
      return "+".concat(total, " .........");
    },
    date: 'Data',
    time: 'Czas',
    event: 'Wydarzenie',
    noEventsInRange: 'Brak wydarzeń.',
  }

  i18n.dayNames = [
    "Nd",
    "Pn",
    "Wt",
    "Śr",
    "Cz",
    "Pt",
    "Sb",
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota",
  ];
  
  i18n.monthNames = [
    "Sty",
    "Lut",
    "Mar",
    "Kwi",
    "Maj",
    "Cze",
    "Lip",
    "Sie",
    "Wrz",
    "Paź",
    "Lis",
    "Gru",
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ];


  const calendarRef = createRef();;

  updateCurrentEventDate(currentCalendarDate);


  useEffect(() => {
    addResourceListener((list: any) => {
      var l: any = [];
      list.map((item: any) => {
        if (getCurrentUser().resources.includes(item.resourceId)) {
          l.push(item);
        }
      })
      setResources(l);
      //setSelectedResources(l);
    });
    addEventListener((list: any) => {
      setEvents(list);
    });
    addClientListener((list: any) => {
      //tylko do odwiezenie widoku po aktualizacji klienta
      setClients(list);
    });
    addUserListener((users: any) => {
      var list = [];
      for (var i = 0; i < users.length; i++) {
          if (users[i].enabled) {
              list.push(users[i]);
          }
      }
      setUsers(list);
    });
    addSettingsListener((s: any) => {
      for (var i = 0; i < s.length; i++) {
        switch (s[i].id) {
          case "managerSettings":
            setManagerSettings(s[i]);
            break;
        }

      }
    });

  }, []);




  const [initData, setInitData] = useState({});

  const [presentEventEditor, dismissEventEditor] = useIonModal(EventEditor, {
    initData: initData,
    onDismiss: (data: {}, role: string) => dismissEventEditor(data, role)
  });


  function openModal(e: any = null) {
    //console.log("openModal", e);
    if (e === null) {
      const start = currentCalendarDate;
      start.setHours(8);
      start.setMinutes(0);
      start.setSeconds(0);
      start.setMilliseconds(0);

      setInitData({ comments: '', resourceId: getCurrentUser().resources[0], time: 60, start: start, userId: getCurrentUser().id });
    } else if (e.resourceId === undefined) { //tu ma być sprawdzanie tylko undefined
      //setView('day')
      //@ts-ignore
      setDefaultView(Views.DAY)
      setCurrentCalendarDate(e.start)
      return;
    } else if (e.action !== undefined && e.action === "click") {

      var initData = { comments: '', resourceId: getCurrentUser().resources[0], time: 60, start: new Date(e.start), userId: getCurrentUser().id }

      if (e.resourceId !== undefined && e.resourceId == null) {
        initData.resourceId = e.resourceId;
      } else {
        initData.resourceId = getCurrentUser().resources[0];
      }
      setInitData(initData);

    } else {
      e.time = (e.end.getTime() - e.start.getTime()) / 60 / 1000;
      if (e.userId === undefined) {
        e.userId = getCurrentUser().id;
      }
      if (e.resourceId === undefined || e.resourceId == null) {
        e.resourceId = getCurrentUser().resources[0];
      }
      setInitData(e);
      if (e.id !== undefined) {
        if (getCurrentUser().role !== "manager" && getCurrentUser().role !== "reception" && e.userId !== getCurrentUserUID()) {
          return;
        }
      }
    }
    presentEventEditor({
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === 'confirm') {
          addEvent(ev.detail.data);
        } else if (ev.detail.role === 'confirmAll') {
          addEvent(ev.detail.data, true);
        } else if (ev.detail.role === 'remove') {
          removeEvent(ev.detail.data.id, ev.detail.data.allInFuture);
        } else if (ev.detail.role === 'redirect') {
          history.push(ev.detail.data);
        }

      }
    });
  }

  var a: EventProps;

  function getDateChange() {
    var d = (24 * 60 * 60 * 1000);
    //@ts-ignore
    if (defaultView === Views.WEEK || defaultView === Views.WORK_WEEK) {
      d *= 7;
    }
    //@ts-ignore
    if (defaultView === Views.MONTH) {
      d *= new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth() + 1, 0).getDate();
    }
    return d;
  }

  function nextDate() {
    setCurrentCalendarDate(new Date(currentCalendarDate.getTime() - getDateChange()))
  }

  function previousDate() {
    setCurrentCalendarDate(new Date(currentCalendarDate.getTime() + getDateChange()))
  }

  function changeResources() {

    if (selectedResources.length === resources.length) {
      setSelectedResources([]);
    } else {
      setSelectedResources(resources);
    }

  }

  function changeUsers() {
    if (selectedUsers.length === 0) {
      setSelectedUsers([getCurrentUser()]);
      setEventUsers([getCurrentUser()]);
    } else {
      setSelectedUsers([]);
      setEventUsers([]);
    }

  }

  function getDate(hour = 8, d = new Date()): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour)
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Kalendarz</IonTitle>
        </IonToolbar>

        <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
          {resources.length > 1 ? <div style={{ display: "flex" }}>
            <div>
              <IonButton size="small" onClick={(e) => { changeResources() }}><IonIcon icon={gridOutline}  ></IonIcon></IonButton>
            </div>

            <div style={{ display: "flex" }}>

              <IonSelect style={{ maxWidth: "140px" }} placeholder="pokoje" multiple={true} onIonChange={(e) => setSelectedResources(e.detail.value)} value={selectedResources}>
                {resources.map((r: any) => {
                  return <IonSelectOption key={r.resourceId} value={r}>{r.resourceTitle}</IonSelectOption>
                })}
              </IonSelect>
            </div>

          </div> : ""}

          {!getCurrentUser().onlyOwnEvents ? <div style={{ display: "flex" }}>
            <div>
              <IonSelect style={{ maxWidth: "140px" }} placeholder="uzytkownicy" multiple={true} onIonChange={(e) => { setSelectedUsers(e.detail.value); setEventUsers(e.detail.value); }} value={selectedUsers}>
                {users.map((u: any) => {
                  return <IonSelectOption key={u.id} value={u}>{u.surname + " " + u.name}</IonSelectOption>
                })}
              </IonSelect>
            </div>
            <div>
              <IonButton size="small" onClick={(e) => { changeUsers() }}><IonIcon icon={peopleOutline}  ></IonIcon></IonButton>
            </div>
          </div> : ""}


        </div>

        <div><IonSegment value={defaultView} onIonChange={(v) => {
          //@ts-ignore
          setDefaultView(v.detail.value)
        }}>
          <IonSegmentButton value={Views.DAY}>
            <IonLabel>Dzień</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={Views.WORK_WEEK}>
            <IonLabel>Tydzień</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={Views.MONTH}>
            <IonLabel>Miesiąc</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={Views.AGENDA}>
            <IonLabel>Agenda</IonLabel>
          </IonSegmentButton>
        </IonSegment></div>

        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ display: "flex", marginLeft: "auto", marginRight: "auto" }}>
            <div>
              <IonButton size="small" onClick={(e) => { setCurrentCalendarDate(getDate()) }}><IonIcon icon={today}  ></IonIcon></IonButton>
            </div>
            <div>
              <div style={{ display: "flex" }}>
                <IonButton size="small" onClick={(e) => { nextDate() }}><IonIcon icon={chevronBack}  ></IonIcon></IonButton>
                <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
                {
                  //@ts-ignore
                  defaultView===Views.DAY?<IonButton style={{width:"40px"}} size="small" color="light">{dateformat(currentCalendarDate, "ddd")}</IonButton>
                :""}
                <IonButton size="small" onClick={(e) => { previousDate() }}><IonIcon icon={chevronForward}  ></IonIcon></IonButton>
              </div>
            </div>
          </div>
        </div>


      </IonHeader>

      <IonContent fullscreen>
        <PushNotification />
        <Calendar

          selectable
          localizer={localizer}
          //dayLayoutAlgorithm="no-overlap"
          defaultDate={currentCalendarDate}

          date={currentCalendarDate}
          min={getDate(managerSettings.calendarStartHour)}
          max={getDate(managerSettings.calendarEndHour)}
          //onNavigate={(v) => { setCurrentCalendarDate(v); console.log("onNavigate", v) }}
          onNavigate={(v) => { setCurrentCalendarDate(v) }}
          onView={(v) => {
            //@ts-ignore
            setDefaultView(v)
          }}
          view={defaultView}
          views={['month', 'week', 'work_week', 'day', 'agenda']}
          step={15}
          timeslots={4}
          events={events}


          // @ts-ignore
          resourceIdAccessor="resourceId"

          resources={selectedResources.length > 0 ? selectedResources : undefined}
          // @ts-ignore
          resourceTitleAccessor="resourceTitle"
          //onEventDrop={this.onEventDrop}
          //onEventResize={this.onEventResize}
          eventPropGetter={(e) => {
            // @ts-ignore
            var backgroundColor = e.bgColor ? e.bgColor : 'blue';
            // @ts-ignore
            const color = e.color ? e.color : 'white';
            // @ts-ignore
            const textDecoration = e.textDecoration ? e.textDecoration : '';
            // @ts-ignore
            const user = getUser(e.userId);
            if (user !== undefined) {
              backgroundColor = user.color;
            }

            return { style: { backgroundColor, color, textDecoration } }
          }}

          onSelectSlot={(e) => { openModal(e) }}
          onSelectEvent={(e) => { openModal(e) }}

          messages={translate}


          formats={{ eventTimeRangeFormat: () => { return "" } }}

          //@ts-ignore
          components={{
            //@ts-ignore
            toolbar: CustomToolbar,
            day: {
              event: CustomEventDayView,
            },
            week: {
              event: CustomEventView,
            },
            agenda: {
              event: CustomEventDayView,
            },
            work_week: {
              event: CustomEventView,
            },
            month: {
              event: CustomEventMonthView,
            },
          }
          } // <- Custom toolbar
        />
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => openModal()}>
            <IonIcon icon={add}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
      <IonModal keepContentsMounted={true}>
        <IonDatetime id="datetime" value={currentCalendarDate.toISOString()} presentation="date" onIonChange={(e) => { setCurrentCalendarDate(getDate(8, new Date(e.detail.value + ''))) }}></IonDatetime>
      </IonModal>
    </IonPage>
  );
};

export default CalendarTab;
